
import { Component, Vue, Prop } from 'vue-property-decorator';
import TInputCloseBtn from '@/components/btns/TInputCloseBtn.vue';

@Component({
  components: {
    TInputCloseBtn,
  },
})
export default class SuburbSearchField extends Vue {
  @Prop(String) public value: string;
  @Prop(Function) public parseInput: () => void;

  get searchValue() {
    return this.value;
  }

  set searchValue(value) {
    this.$emit('input', value);
  }
}
